import React from 'react'

import LocationSearch from 'components/shared/LocationSearch'

const InformationEdit = ({
  name,
  displayLocation,
  handleNameChange,
  handleLocationChange,
}) => {
  return (
    <form className="drift-form" style={{ paddingTop: 25 }}>
      <div className="dsg-Label color-navy-dark">name</div>
      <input
        type="text"
        style={{ width: '100%', marginBottom: 10, marginTop: 3 }}
        required
        value={name}
        onChange={handleNameChange}
      />
      <div className="dsg-Label color-navy-dark" style={{ marginBottom: 3 }}>location</div>
      <LocationSearch
        placeholder=""
        initialValue={displayLocation}
        types={['(cities)']}
        onSuggestSelect={handleLocationChange}
      />
    </form>
  )
}

export default InformationEdit



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TitleCard/InformationEdit.js